var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_PRODUCTS = 'api/product';
const GET_SET_PRODUCTS_CUSTOMERS_APP = 'api/v2/washdayapp/products';
export const getById = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_PRODUCTS}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching getById:', error);
            throw error;
        }
    });
};
export const getByIdCustomersApp = function (id, storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const storeQuery = storeId
                ? `?storeId=${encodeURIComponent(storeId)}`
                : "";
            const response = yield this.axiosInstance.get(`${GET_SET_PRODUCTS_CUSTOMERS_APP}/${id}${storeQuery}`, config);
            return ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.product) || {};
        }
        catch (error) {
            console.error("Error fetching getByIdCustomersApp:", error);
            throw error;
        }
    });
};
export const getProductSupplies = function (storeId, productId) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {
            headers: { Authorization: `Bearer ${this.apiToken}` },
        };
        return this.axiosInstance.get(`api/stores/${storeId}/products/${productId}/supplies`, config);
    });
};
